// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard';
export const DRAWER_WIDTH = 248;
export const MINI_DRAWER_WIDTH = 90;


const config = {
  fontFamily: `'Public Sans', sans-serif`
};

export default config;
